import React, { useState } from "react";
import Spinner from "../loading/spinner";

const ModalSelect = ({ reset, event, onConfirm, onCancel }) => {
  const [loading, setLoading] = useState(false);

  const handleConfirm = () => {
    if (onConfirm) onConfirm();
    else reset();
  };

  const handleCancel = () => {
    if (onCancel) onCancel();
    else reset();
  };

  return (
    <>
      <div className="fixed inset-0 z-50 overflow-y-auto bg-black/30 backdrop-blur-sm flex items-center justify-center p-4">
        <div className="bg-white rounded-2xl shadow-2xl max-w-sm w-full p-6">
          <p className="text-lg font-bold text-gray-800 mb-2">Confirm Deletion</p>
          <p className="text-gray-600">
            Are you sure you want to delete this schedule?
            {event && <span className="font-semibold text-indigo-600"> {event.title}</span>}
          </p>
          <div className="flex justify-end gap-3 mt-6">
            <button
              onClick={handleCancel}
              className="px-5 py-2 bg-gray-100 hover:bg-gray-200 text-gray-700 rounded-xl transition"
            >
              Cancel
            </button>
            <button
              onClick={handleConfirm}
              className="px-5 py-2 bg-red-600 hover:bg-red-700 text-white rounded-xl shadow-md transition"
            >
              Delete
            </button>
          </div>
        </div>
      </div>
      {loading && <Spinner />}
    </>
  );
};

export default ModalSelect;